<template>
  <div class="transportation_ui pb-2">
    <hgroup class="flex mb-1">
      <div class="mr-2">
        <p class="mt-0 mb-0">I need transportation</p>
        <small class="text-pencil"
          >Transportation is offered from most hotels in the downtown
          area.</small
        >
      </div>
      <div>
        <toggle
          :name="'transportation_toggle'"
          v-model="activeProductDetails.NeedTransportation"
        />
      </div>
    </hgroup>

    <div v-show="activeProductDetails.NeedTransportation">
      <fieldset class="wrap_hotel_input mt-0">
        <input
          id="hotel_input"
          autocomplete="off"
          style="display: block; width: 100%;"
          type="text"
          placeholder="Enter the name of your hotel"
          v-on:keyup="lookUpHotel"
          class="button large _shadow outline"
          :class="{
            'scale-animation': !activity.HotelAddress,
            'bg-mist': activity.HotelAddress
          }"
          v-model="activity.HotelName"
        />
        <label v-if="activity.HotelAddress" for="hotel_input" class="after"
          >Edit</label
        >
      </fieldset>

      <small
        style="display: block;"
        class="mb-1 text-pencil"
        v-if="activity.HotelAddress"
        >{{ activity.HotelAddress }}</small
      >
    </div>
    <!-- <router-link
      v-show="activeProductDetails.NeedTransportation"
      class="button large _shadow outline"
      :to="'transportation/'+entityHierarchyKey"
      activeClass="active"
    >
      <span class="text-blue">Enter your hotel</span>
    </router-link>-->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "TransportationUI",
  props: ["entityHierarchyKey", "activity"],
  data: function() {
    return {
      //textVal: true
      //HotelAddress: false
    };
  },
  computed: {
    ...mapGetters(["activeProductDetails"]),
    ...mapState(["client"])
  },
  methods: {
    lookUpHotel: function(e) {
      // console.log("lookUpHotel()");

      //var val = e.target.value;
      var tis = this;
      //this.HotelAddress = "";

      this.$set(this.activity, "HotelAddress", "");

      //var sw = new google.maps.LatLng(21.292830, -158.104816);
      //var ne = new google.maps.LatLng(21.711919, -157.977100);

      // var sw = new google.maps.LatLng(
      //   this.$store.state.mapCoordinates.sw.lat,
      //   this.$store.state.mapCoordinates.sw.long
      // );
      // var ne = new google.maps.LatLng(
      //   this.$store.state.mapCoordinates.ne.lat,
      //   this.$store.state.mapCoordinates.ne.long
      // );

      //var bounds = new google.maps.LatLngBounds(sw, ne);

      var geolocation = {
        lat: this.client.Latitude,
        lng: this.client.Longitude
      };

      // console.log("geolocation", geolocation);
      // console.log(
      //   "this.client.HotelSearchRadius",
      //   this.client.HotelSearchRadius
      // );
      var radius = 0;

      if (this.client.HotelSearchRadius) {
        radius = this.client.HotelSearchRadius * 1 * 1.609344;
      }

      // eslint-disable-next-line no-undef
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: radius
      });

      // eslint-disable-next-line no-undef
      var autocomplete = new google.maps.places.Autocomplete(e.target, {
        bounds: circle.getBounds(),
        types: ["establishment"],
        componentRestrictions: {
          country: this.client.CountryCode
        }
      });

      // eslint-disable-next-line no-undef
      google.maps.event.addListener(autocomplete, "place_changed", () => {
        var place = autocomplete.getPlace();

        // console.log("place");
        // console.log(place);

        //tis.activity.HotelName      = place.name;
        tis.$set(this.activity, "HotelName", place.name);

        //tis.activity.HotelLatitude  = place.geometry.location.lat();
        tis.$set(this.activity, "HotelLatitude", place.geometry.location.lat());
        tis.$set(
          this.activity,
          "HotelLongitude",
          place.geometry.location.lng()
        );

        //tis.activity.HotelLongitude = place.geometry.location.lng();
        // tis.$set(this.activity, "HotelLatitude", place.geometry.location.lat());
        // tis.$set(
        //   this.activity,
        //   "HotelLongitude",
        //   place.geometry.location.lng()
        // );

        //this.HotelAddress = place.formatted_address;
        this.$set(this.activity, "HotelAddress", place.formatted_address);
      });

      if (this.activity.HotelName == "") {
        //this.activity.HotelLatitude  = null;
        this.$set(this.activity, "HotelLatitude", null);

        //this.activity.HotelLongitude = null;
        this.$set(this.activity, "HotelLongitude", null);

        //this.HotelAddress = false;
        this.$set(this.activity, "HotelAddress", false);
      }
    }
  }
};
</script>

<style></style>
